import { Chip, Divider, Stack, } from '@mui/material';
import React, { useState } from 'react'
import Product ,{Vendors,Procurement,Summary} from './Components/SalesTabs';




const categories = ["Products","Vendors","Procurement",'Summary'];


function SalesInv() {

  const [salestabs, setsalestabs] = useState(<Product/>)
    const [bcolor, setbColor] = useState([
                "secondary",
                "primary",
                "primary",
                "primary",
           
                
              ]);
              let resetColor = [
                "primary",
                "primary",
                "primary",
                "primary",
            
                
              ];
              const handleClick = (n,cat) => {
                let newArray = [...resetColor];
                newArray[n] = "secondary";
                setbColor(newArray);
                switch(cat){
                  case categories[0]:setsalestabs(<Product/>); break;
                  case categories[1]:setsalestabs(<Vendors/>); break;
                  case categories[2]:setsalestabs(<Procurement/>); break;
                  case categories[3]:setsalestabs(<Summary/>); break;
                  default:

                }
                
              };  
          return (
            <div>
              {/* remove/ add/ edit user perms */}
              <Stack direction={"column"} mb={2}>
                <Stack direction={"row"}>
                  {categories.map((cat, index) => {
                    return (
                      <Chip
                        sx={{ marginRight: 2 }}
                        label={cat}
                        color={bcolor[index]}
                        onClick={() => handleClick(index,cat)}
                      />
                    );
                  })}
                  
                </Stack>
              </Stack>
              <Divider variant="middle" orientation="horizontal" />
              {salestabs}
                </div>
            )
        }

export default SalesInv
